<template>
    <Form @submit="save" :validation-schema="schema">
      <div class="d-flex justify-content-center flex-column align-items-center" style="position: relative; width:100%;height:100%" >

       <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    
      <div>
        <div class="title d-flex justify-content-center" >
           
         <span v-if="group!=undefined">修改选题</span>
         <span v-else>新增分组</span>
       </div>
        <div>
           <div class="mt-1 textbox_label">
            名称：</div>
        <div class="d-flex justify-content">
             <Field type="text" name="name" id="name" 
                            class="textBox" 
                            v-model="name"
                            placeholder="请输入你的分组名称" />
        </div>
        <div><ErrorMessage name="name" class="textbox textbox_label error-message"/></div> 
        </div>

      
      </div>
   
 
      <div class="textBox mt-1">
          <div class="textbox_label dropdown">
            <div class="mt-1 mb-1">适用账号:</div>
                <div v-for="(account, index) in accounts" :key="index">
                    <label  v-if="account.user_info.nickname!=undefined">
                        <input type="checkbox" v-model="selectedAccounts" :value="account.objectId">
                        {{ account.user_info.nickname }}
                    </label>
                </div>
          </div>
        
      </div>

        <div class="error-message mt-1">
                                {{  errors}}
                            </div>
        <div class="mt-1">
          <button type="submit" v-if="!isSubmit" class="blueBtn submitBtn">提交</button>
          <button v-else class="blueBtn submitBtn btnDiabled">提交</button>
        </div>
      </div>
    </Form>



</template>

<script>
import axios from 'axios';
import { Form, Field,ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import GridLoader from 'vue-spinner/src/GridLoader.vue'

export default {
data(){
const schema = yup.object({

  name: yup.string().required("请输入分组名称"),
 
});


return {
    isLoading:false,
    accounts:[],
    name:'',
    selectedAccounts:[],
    schema,
    errors:'',
    isSubmit:false,
    spinnerColor:"#262626"
}
},
props: ["group"],
components: {
    Form,
    Field,
    ErrorMessage,
    GridLoader
},
setup(){

 var token=localStorage.getItem('sessionToken')
 axios.defaults.headers.common['X-Parse-Session-Token'] = token

},


mounted(){ 
    if(this.group!=undefined)
    {
        this.selectedAccounts=this.group.account_ids
        this.name=this.group.name
    } 
    this.getAccounts()
},
methods:{
    async getAccounts(){
      try{
        this.isloading=true;
        const response = await axios.get(this.domain+'xhs/get_valid_accounts');
        var data=response.data
        if(data.status=='Suc')
        {
            var results=data.accounts
            this.accounts=results;
        }
        else
        {
            console.error(data)
        }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isloading=false;
      }
    },

    async save(values){
        try{
            this.isLoading=true
            if(this.selectedAccounts.length==0)
            {
                this.errors='请选择适用的账号'
                return

            }
            var id=null;
            if(this.group!=undefined)
            {
                id=this.group.objectId
            }
            const response = await axios.post(this.domain+'xhs/save_sucai_group',
            {
                'id':id,
                'name':values.name,
                'account_ids':this.selectedAccounts
            });
            var data=response.data
            if(data.status=='Suc')
            {
                var results=data.group
                this.$emit('add_suc', results);
            }
            else
            {
                console.error(data)
            }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isLoading=false
      }

    },



},


};
</script>
<style scoped>


.error-message{
color:red
}

</style>


